import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateCurrencyModal from "../../components/Settings/Currency/CreateCurrencyModal.vue";
import CurrencyList from "../../components/Settings/Currency/CurrencyList.vue";
import { useCurrency } from "../../composables/useCurrency";


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrncyListPage',
  setup(__props) {

const {
  searchQuery,
  filteredCurrencies,
  showModal,
  selectedCurrency,
  form,
  errors,
  loading,
  paginationConfig,
  fetchCurrencies,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  saveCurrency,
  deleteCurrency,
} = useCurrency();

onMounted(fetchCurrencies);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "currency_page.list_title" }),
      _createVNode(CurrencyList, {
        currencies: _unref(filteredCurrencies),
        "search-query": _unref(searchQuery),
        "pagination-config": _unref(paginationConfig),
        "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => (searchQuery.value = $event)),
        onCreate: _unref(openCreateModal),
        onEdit: _unref(openEditModal),
        onDelete: _unref(deleteCurrency)
      }, null, 8, ["currencies", "search-query", "pagination-config", "onCreate", "onEdit", "onDelete"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter),
      _createVNode(CreateCurrencyModal, {
        open: _unref(showModal),
        "is-edit": !!_unref(selectedCurrency),
        form: _unref(form),
        errors: _unref(errors),
        loading: _unref(loading),
        onClose: _unref(closeModal),
        onSave: _unref(saveCurrency),
        onUpdateField: _unref(updateField)
      }, null, 8, ["open", "is-edit", "form", "errors", "loading", "onClose", "onSave", "onUpdateField"])
    ])
  ], 64))
}
}

})